

import modelBase from '../../models/model-base.model';

var announcementManagementModel = {
  getUserDetails: function (successCallBack, failureCallBack, announcementId) {

    modelBase.get(successCallBack, failureCallBack, '/api/announcement/' + announcementId);
  },

  downloadZip: (successCallBack, failureCallBack, fileIds, fileName) => {
    var params = {};
    var path = '/api/retail/file/download/multiple';
    params.FileIDs = fileIds;
    modelBase.postDownload(successCallBack, failureCallBack, path, { body: params }, fileName + ".zip");
  },

}

export default announcementManagementModel;
